module.exports = __webpack_public_path__ + "img/slide10.428e5de9.png";